import React from 'react'

const Vimeo = ({ videoId }) => {
  return (
    <div className='w-full h-full dark:bg-gray-900 aspect-[4/2.75] sm:aspect-video'>
      <iframe
        src={`https://player.vimeo.com/video/${videoId}`}
        width='100%'
        height='100%'
        allow='autoplay; fullscreen; picture-in-picture'
        allowFullScreen
        title='Vimeo Video'
        className='bg-gray-900 dark:bg-gray-900 '
      ></iframe>
    </div>
  )
}

export default Vimeo
